import React from 'react';
import PropTypes from 'prop-types';
import InstagramIcon from '@tradera/blueprint/theme/icons/instagram.svg?jsx';

const InstagramPost = props => {
    const { postId, width, height } = props;
    return (
        <a
            className="mr-3 position-relative"
            href={`https://www.instagram.com/p/${postId}`}
            target="_blank"
            rel="nofollow noopener noreferrer">
            <img
                src={`https://www.instagram.com/p/${postId}/media/?size=m`}
                alt="instagram image 1"
                width={width}
                height={height}
            />
            <InstagramIcon className="social-media-slider__instagram__icon icon icon-white position-absolute mr-2 mt-2" />
        </a>
    );
};

InstagramPost.propTypes = {
    postId: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
};

export default React.memo(InstagramPost);
